import React, { useState } from 'react';
import styles from '../css/RangeSlider.module.scss';

const RangeSlider = ( {minRange, maxRange, minValue, maxValue, setMinValue, setMaxValue}) => {
    const handleMinChange = (e) => {
        const value = Math.min(Number(e.target.value), maxValue - 1);
        setMinValue(value);
    };
    const handleMaxChange = (e) => {
        const value = Math.max(Number(e.target.value), minValue + 1);
        setMaxValue(value);
    };

    return (
        <div className={styles.rangeSlider}>
            <input
                type="range"
                className={`${styles.thumb} ${styles.thumbLeft}`}
                min={minRange}
                max={maxRange}
                value={minValue}
                onChange={handleMinChange}
            />
            <input
                type="range"
                className={`${styles.thumb} ${styles.thumbRight}`}
                min={minRange}
                max={maxRange}
                value={maxValue}
                onChange={handleMaxChange}
            />
            <div className={styles.slider}>
                <div
                    className={styles.sliderTrack}
                    style={{
                        left: `${((minValue - minRange) / (maxRange - minRange)) * 100}%`,
                        right: `${100 - ((maxValue - minRange) / (maxRange - minRange)) * 100}%`,
                    }}
                ></div>
            </div>
            <div className={styles.labels}>
                <span>${minValue}</span>
                <span>${maxValue}</span>
            </div>
        </div>
    );
};

export default RangeSlider;
